module.exports = __webpack_public_path__ + "img/subject_2.8e674572.png";